/**
 * 获取url的参数
 * @param {*} name 参数名
 */
export function getParam(name){
    var url = location.href.split('?')[1]
    var array = []
    if(url){
        array = url.split('&')
        for(var i of array){
            if( i.split('=')[0]==name )
                return decodeURIComponent(i.split('=')[1])
        }
    }
}
/**
 * 获取微信回调里的参数
 * @param {*} name 参数名
 */
export function getWXCallParam(name){
    //https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0ec7d4b034f14c14&redirect_uri=https%3a%2f%2fshare.wandian.net.cn%2f%23%2fgame%2flogin&response_type=code&scope=snsapi_base&connect_redirect=1&state={"redirect":"/game/my"}#wechat_redirect
    //https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0ec7d4b034f14c14&redirect_uri=https%3a%2f%2fshare.wandian.net.cn%2f%23%2fgame%2flogin&response_type=code&scope=snsapi_base&connect_redirect=1&state={"redirect":"/game/my","loginMethod":1}#wechat_redirect
    //https://share.wandian.net.cn/?code=061X2KuV1fEmj11QE9sV1G4KuV1X2Kuf&state=%7B%22redirect%22%3A%22%2Fgame%2Fmy%22%7D#/game/login
    var url = decodeURIComponent(location.href).split('&state=')[1].split('#')[0]
    //{"redirect":"/game/my"}
    if(url){
        return JSON.parse(url)[name]
    }
}

/**
 * @param {String} src 地址
 * @param {Function} callback 回调函数
 */
export function createScript(src,callback = function(){}){
    for(var i of document.getElementsByTagName('script')){
        if(i.src==src){
            console.error('重复添加'+src)
            callback()
            return
        }
    }
    var script =document.createElement('script')
    script.src=src
    script.onreadystatechange = function() {
        if(jsNode.readyState == 'loaded' || jsNode.readyState == 'complete') {
            // 异步js加载完毕
            // do something执行操作
            console.info('==============')
            callback()
        }
    }
    document.getElementsByTagName('head')[0].appendChild(script)
}